import { Component } from '@angular/core';



@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],
})
export class LandingPageComponent {


  constructor() {}

  backgroundImages: string[] = [
    '../../assets/images/home/image2_new.JPG',
    '../../assets/images/home/image1_new.jpg',
    '../../assets/images/home/image3_new.JPG',
    '../../assets/images/home/image4_new.JPG',
    '../../assets/images/home/image5_new.jpg',
    
  ];

  currentSlide = 0;
  private intervalId: any;

  ngOnInit() {
    this.startSlider();
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private startSlider() {
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.backgroundImages.length;
  }


}
